import { render, staticRenderFns } from "./QuizFinalCommentView.vue?vue&type=template&id=992c8ce0&"
import script from "./QuizFinalCommentView.vue?vue&type=script&lang=js&"
export * from "./QuizFinalCommentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports